import { useState, useContext, useEffect } from 'react';
import "./LoginPage.css";
import { Formik } from 'formik';
import axios from 'axios';
import { site_url } from "./../config.js";
import { Link } from "react-router-dom";
import { AuthContext } from '../AuthContext';
import { Navigate, useNavigate } from 'react-router-dom';
import { useLocation } from "react-router-dom";

function Index({ children }) {

  const [msg, setMsg] = useState([]);
  const [otpSent, setOtpSent] = useState(false);
  const [phone, setPhone] = useState('');
  const [otp, setOtp] = useState('');
  const [resendTimer, setResendTimer] = useState(0);
  const [loading, setLoading] = useState(false);
  const { user, login, setUser } = useContext(AuthContext);

  const location = useLocation();

  useEffect(() => {
    // Remove modal backdrops
    const backdrops = document.querySelectorAll(".modal-backdrop");
    backdrops.forEach((el) => el.remove());

    // Remove modal-open class
    document.body.classList.remove("modal-open");

    // Remove inline styles like overflow and padding
    document.body.style.overflow = "";
    document.body.style.paddingRight = "";
  }, [location]);

  const navigate = useNavigate();

  useEffect(() => {
    if (user) {
      return navigate('/home');
    }
  }, [user])

  // Resend timer countdown
  useEffect(() => {
    if (resendTimer > 0) {
      const timer = setTimeout(() => {
        setResendTimer(resendTimer - 1);
      }, 1000);
      return () => clearTimeout(timer);
    }
  }, [resendTimer]);

  const sendOTP = async () => {
    if (!phone || phone.length !== 10) {
      setMsg({ status: 'failed', message: 'Please enter a valid 10-digit phone number' });
      return;
    }

    setLoading(true);
    setMsg({});

    try {
      const response = await axios.post(site_url + '/vendor/send-login-otp', { phone });

      if (response.data.status === 'success') {
        setOtpSent(true);
        setResendTimer(60); // 60 seconds countdown
        setMsg({ status: 'success', message: 'OTP sent successfully to your phone' });
      } else {
        setMsg({ status: 'failed', message: response.data.message || 'Failed to send OTP' });
      }
    } catch (error) {
      console.error(error);
      setMsg({ status: 'failed', message: 'Failed to send OTP. Please try again.' });
    } finally {
      setLoading(false);
    }
  };

  const verifyOTP = async () => {
    if (!otp || otp.length !== 4) {
      setMsg({ status: 'failed', message: 'Please enter a valid 4-digit OTP' });
      return;
    }

    setLoading(true);
    setMsg({});

    try {
      const response = await axios.post(site_url + '/vendor/login', { phone, otp });

      if (response.data.status === 'success') {
        // Store tokens properly
        localStorage.setItem('access_token', response.data.token);
        localStorage.setItem('jwt_token', response.data.token);
        localStorage.setItem('user_id', response.data.user_id); // Store user_id
        if (response.data.device_token) {
          localStorage.setItem('device_token', response.data.device_token);
        }

        // Set user context with token
        setUser(response.data.user_id);
        
        // Set session for  verification
        sessionStorage.setItem("mpin_verified", "true");
        
        // Navigate to home
        navigate('/home');
      } else {
        setMsg({ status: 'failed', message: response.data.message || 'Invalid OTP' });
      }
    } catch (error) {
      console.error(error);
      setMsg({ status: 'failed', message: 'Invalid OTP. Please try again.' });
    } finally {
      setLoading(false);
    }
  };

  const handleResendOTP = () => {
    setOtp('');
    sendOTP();
  };

  return (
    <div className="login-container">
      <div className="login-header">
        <img
          src="https://static.vecteezy.com/system/resources/previews/001/082/517/non_2x/digital-marketing-concept-store-front-vector.jpg"
          alt="Truck"
          className="header-image"
        />
      </div>
      <div className="login-form">
        <form onSubmit={(e) => { e.preventDefault(); otpSent ? verifyOTP() : sendOTP(); }}>
          <h2>Vendor Login</h2>

          {msg.status === 'failed' && (
            <div className="alert alert-danger mb-1" role="alert">
              {msg.message}
            </div>
          )}

          {msg.status === 'success' && (
            <div className="alert alert-success mb-1" role="alert">
              {msg.message}
            </div>
          )}

          <div className="form-group">
            <label htmlFor="phone">
              <i className="fa fa-phone"></i>
            </label>
            <input
              type="number"
              name="phone"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
              id="phone"
              placeholder="Enter Your Mobile Number"
              maxLength="10"
              disabled={otpSent}
            />
          </div>

          {otpSent && (
            <>
              <br />
              <div className="form-group">
                <label htmlFor="otp">
                  <i className="fa fa-lock"></i>
                </label>
                <input
                  type="number"
                  name="otp"
                  value={otp}
                  onChange={(e) => setOtp(e.target.value)}
                  id="otp"
                  placeholder="Enter 4-digit OTP"
                  maxLength="4"
                />
              </div>
            </>
          )}

          <br />

          {!otpSent ? (
            <button type="submit" disabled={loading} className="login-button">
              {loading ? 'Sending OTP...' : 'Send OTP'}
            </button>
          ) : (
            <>
              <button type="submit" disabled={loading} className="login-button">
                {loading ? 'Verifying...' : 'Verify OTP'}
              </button>
              <br />
              <button
                type="button"
                onClick={handleResendOTP}
                disabled={resendTimer > 0 || loading}
                className="login-button"
                style={{ marginTop: '10px', backgroundColor: resendTimer > 0 ? '#ccc' : '#007bff' }}
              >
                {resendTimer > 0 ? `Resend OTP in ${resendTimer}s` : 'Resend OTP'}
              </button>
            </>
          )}

          <p className="register-text"></p>
        </form>
      </div>
    </div>
  );
}

export default Index;
